import IconDangerTriangle from "@/app/(components)/generics/Icons/IconDangerTriangle";
import styles from "./ErrorMessage.module.css";

type Props = {
  message: string;
};

export default function ErrorMessage(props: Props) {
  return (
    <p className={styles.errorMessage}>
      <IconDangerTriangle />
      {props.message}
    </p>
  );
}
